import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Problema from '../../../../assets/images/question.png';
import Foto1 from '../../../../assets/images/problematica.png';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';

function Problematica() {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Popover Information</Popover.Header>
      <Popover.Body>
        Here is some <strong>interesting</strong> information about connected devices and their impact on Wi-Fi networks.
      </Popover.Body>
    </Popover>
  );

  const PopoverButton = () => (
    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
      <Button variant="outline-primary" style={{ padding: '0 5px', margin: '0 5px', fontSize: 'inherit' }}>dispositivos conectados </Button>
    </OverlayTrigger>
  );

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-sm-12 col-md-6'>
            <h1>Problemática das Redes Wi-Fi</h1>
            <img src={Problema} alt='problema' className='img-fluid mb-0' />
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header><div className='opcoes'>Crescimento da Demanda: </div></Accordion.Header>
                <Accordion.Body>
                  <div className='opcoes'>
                  Com o aumento expressivo de dispositivos <PopoverButton /> impacta diretamente no desempenho das redes Wi-Fi.
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header><div className='opcoes'>Principais Problemas: </div></Accordion.Header>
                <Accordion.Body>
                <div className='opcoes'>Cobertura inadequada, obstáculos/barreiras, capacidade, confiabilidade limitadas e custos elevados são problemas frequentes.
                </div>
                </Accordion.Body>
              </Accordion.Item>
              {/* <Accordion.Item eventKey="2">
                <Accordion.Header>Obstáculos e barreiras: </Accordion.Header>
                <Accordion.Body>
                  A eficiência das redes Wi-Fi pode ser comprometida por diversos obstáculos físicos e ambientais,
                  como paredes de concreto, móveis grandes, superfícies metálicas,
                  vidros tratados, e eletrodomésticos que causam interferências eletromagnéticas.
                </Accordion.Body>
              </Accordion.Item> */}
              <Accordion.Item eventKey="3">
                <Accordion.Header><div className='opcoes'>Custo da tecnologia: </div></Accordion.Header>
                <Accordion.Body>
                <div className='opcoes'>O custo para solucionar problemas de redes Wi-Fi envolve investimentos em tecnologia como roteadores
                  avançados, redes mesh e repetidores de sinal, além de ferramentas de análise e otimização de redes.
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header><div className='opcoes'>Qualificação profissional: </div></Accordion.Header>
                <Accordion.Body>
                <div className='opcoes'>A qualificação profissional é essencial para solucionar problemas de redes Wi-Fi, pois exige conhecimentos
                  técnicos avançados em configuração, otimização e segurança de redes.<br />
                  </div>
                  </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header><div className='opcoes'>Solução de problemas: </div></Accordion.Header>
                <Accordion.Body>
                <div className='opcoes'> Profissionais especializados devem entender tecnologias modernas como Wi-Fi 6E,
                  MU-MIMO, QoS e redes MESH, além de saber utilizar ferramentas de análise e diagnóstico.</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
          <div className='col-sm-12 col-md-6'>
            <div className='imagem'>
              <img className="d-block w-100" src={Foto1} alt="First slide" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Problematica;
